/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  HTTPValidationError,
  ProjectCreateDTO,
  ProjectListResponseDTO,
  ProjectResponseDTO,
  ProjectUpdateDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Projects<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Project
   * @name GetProjectsApiProjectsGet
   * @summary Get Projects
   * @request GET:/api/projects
   * @response `200` `(ProjectListResponseDTO)[]` Successful Response
   */
  getProjectsApiProjectsGet = (params: RequestParams = {}) =>
    this.request<ProjectListResponseDTO[], any>({
      path: `/api/projects`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Project
   * @name CreateProjectsApiProjectsPost
   * @summary Create Projects
   * @request POST:/api/projects
   * @response `200` `ProjectResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  createProjectsApiProjectsPost = (data: ProjectCreateDTO, params: RequestParams = {}) =>
    this.request<ProjectResponseDTO, HTTPValidationError>({
      path: `/api/projects`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Project
   * @name GetProjectsDetailApiProjectsIdGet
   * @summary Get Projects Detail
   * @request GET:/api/projects/{_id}
   * @response `200` `ProjectResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getProjectsDetailApiProjectsIdGet = (id: number, params: RequestParams = {}) =>
    this.request<ProjectResponseDTO, HTTPValidationError>({
      path: `/api/projects/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Project
   * @name UpdateProjectsApiProjectsIdPut
   * @summary Update Projects
   * @request PUT:/api/projects/{_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  updateProjectsApiProjectsIdPut = (id: number, data: ProjectUpdateDTO, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/api/projects/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Project
   * @name DeleteProjectsApiProjectsIdDelete
   * @summary Delete Projects
   * @request DELETE:/api/projects/{_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  deleteProjectsApiProjectsIdDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/api/projects/${id}`,
      method: "DELETE",
      ...params,
    });
}
